export const MAP_SETTINGS_CONCURRENCY_SET_IS_OFFLINE = 'MAP_SETTINGS_CONCURRENCY_SET_IS_OFFLINE';
export const MAP_SETTINGS_CONCURRENCY_SET_ALERT_VISIBILITY = 'MAP_SETTINGS_CONCURRENCY_SET_ALERT_VISIBILITY';
